import * as React from 'react';
import { LiveClassRegistration, LiveClassSession } from '@magoosh/admin/live_class_sessions/types';
import { adminPaths } from 'config/path_helpers';
import { useEffect, useState } from 'react';
import fetch from 'utilities/fetch';
import { Spinner } from '@magoosh/b2b/app/lib/spinner';

interface LiveClassRegistrationsProps {
  session: LiveClassSession;
}

const LiveClassRegistrations: React.FC<LiveClassRegistrationsProps> = (props) => {
  const [registrations, setRegistrations] = useState([]);
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    if (!props.session) {
      setRegistrations([]);
      return;
    }
    setFetching(true);
    fetch(adminPaths.api.liveClassRegistrations({ liveClassSessionId: props.session.id }))
      .then((response) => {
        setRegistrations(response.data);
      })
      .catch((response) => alert(`Something went wrong: ${response.errors}`))
      .finally(() => {
        setFetching(false);
      });
  }, [props.session]);

  return (
    <div>
      {fetching && <Spinner />}
      <ol>
        {registrations.map((registration) => {
          return (
            <li key={registration.id}>
              <a href={adminPaths.user(registration.userId)} target="_blank">
                {registration.userEmail || registration.userName || `User ${registration.userId}`}
              </a>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default LiveClassRegistrations;
